<template>
    <div class="row mt-5">
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 mb-4"
        v-for="category in categories" :key="category._id"
                    :value="category._id"
      >
        <button @click="chooseCategoriesForProvider(category._id, category.name)" data-toggle="tooltip" :title="category.name" class="btn hide-text p-3 btn-block border-dotted text-black text-uppercase font-weight-bold"
              :class="{activeCategory: categoryIds.includes(category._id)}">
              {{$t('providers.step5_add')}}
              {{category.name}}
          </button>
      </div>
    </div>
</template>

<style scoped lang="scss">
  .hide-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
  }
  
  .activeCategory{
    background: var(--primary);
    border: none !important;
  }

  .border-dotted{
    border: 1px dotted #C0C0C0;
  }
</style>


<script>

export default {
  props: {
    categoryIds: Array
  },
  data(){
    return {
      // categoryIds: [],
      categories: []
    }
  },
  watch:{
      categoryIds: function(value) {
        this.$emit("categoryIds", value);
      }
  },
  methods: { 
    chooseCategoriesForProvider(categoryId, categoryName){
      console.log(`vao category ${this.categoryIds}`);
      if(!this.categoryIds.includes(categoryId)){
        this.categoryIds.push(categoryId);
        event.target.innerHTML = categoryName;
      }else{
        var index = this.categoryIds.indexOf(categoryId);
        this.categoryIds.splice(index, 1);
        event.target.innerHTML = this.$t('providers.step5_add')+" "+categoryName;
      }
    },
    async getCategories(){
       try{
         const lang = (localStorage && localStorage.language) || 'en'
          const { data: { results}} = await this.$store.$oddjob.settings.getCategories({statuses:"active", language:lang});
          if(results && results.length > 0){
              return results;
          }
          return [];
       }catch(e){
         console.log("API get categories failed", e);
       }
    },
  },
  async mounted(){
     try{
        this.categories = await this.getCategories();
        // console.log(`category ${categories}`);
     }catch(e){
        console.log(e);
     }
  }
}
</script>